import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getMfaAuth = get('mfaAuth');

export const getIsRequesting = createSelector(getMfaAuth, get('requesting'));
export const getError = createSelector(getMfaAuth, get('error'));
export const getInfo = createSelector(getMfaAuth, get('info'));
export const getMfaRequired = createSelector(getMfaAuth, get('mfaRequired'));
export const getMaskedEmail = createSelector(getMfaAuth, get('maskedEmail'));
